import { ActionTree } from 'vuex'
import { RouterState } from './types'
import { RootState } from '@/store/types'

export const actions: ActionTree<RouterState, RootState> = {
  sync({ commit }, payload) {
    commit('sync', payload)
  },
}
